import * as React from 'react';

import * as styles from './SubAgentListLayout.css';

type TSubAgentsList = {
  isTopTabsRedesigned: boolean;
  subAgentsNode: React.ReactNode;
  rootElementRef: React.RefObject<HTMLDivElement | null>;
  targetElementRef: React.RefObject<HTMLDivElement | null>;
};

export const SubAgentListLayout: React.FC<TSubAgentsList> = ({
  subAgentsNode,
  rootElementRef,
  targetElementRef,
  isTopTabsRedesigned,
}) => {
  return (
    <div className={isTopTabsRedesigned ? styles['container-redesigned'] : styles['container']} ref={rootElementRef}>
      <div className={styles['scroll_container']}>
        {subAgentsNode}
        <div className={styles['target']} ref={targetElementRef} />
      </div>
    </div>
  );
};
